import { AfterViewInit, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router'
import * as feather from 'feather-icons';
import { LayoutService } from '../../../services/layout.service';
import { NavService } from '../../../services/nav.service';
import { fadeInAnimation } from '../../../data/router-animation/router-animation';
import { AuthenticationService } from '../../../../services/authentication.service';
import { CommonService } from '../../../../services/common.service';

@Component({
    selector: 'app-content',
    templateUrl: './content.component.html',
    styleUrls: ['./content.component.scss'],
    animations: [fadeInAnimation]
})
export class ContentComponent implements OnInit, AfterViewInit {
    
    constructor(private _router: Router, private route: ActivatedRoute, public navServices: NavService,
        public layout: LayoutService, private authenticationService: AuthenticationService, public _commonService: CommonService) {
        debugger;
        this.route.queryParams.subscribe((params) => {
            this.layout.config.settings.layout = params.layout ? params.layout : this.layout.config.settings.layout
        })
        //
        //
        let authorizationData: any = this.authenticationService._getLocalStorage("authorizationData");
        this.authenticationService._authentication = authorizationData;

        let authorizationUserData: any = this.authenticationService._getLocalStorage("authorizationUserData");
        this.authenticationService.userData = authorizationUserData;

        

        //notification hubs
    }
    getUserMenu(userId: string, emailAddress: string) {
        this._commonService.getUserModulesAndMenus(userId, emailAddress).subscribe(
            (res: any) => {

                this.authenticationService._setLocalStorage('authorizationUserData', JSON.stringify(res["data"].userData));
                this.authenticationService.userData = res["data"].userData;
                this._commonService.SideBarMenu = [];
                for (var i = 0; i < res["data"].userModules.length; i++) {
                    if (!res["data"].userModules[i].isIWantToMenu) {
                        this._commonService.SideBarMenu.push({
                            path: res["data"].userModules[i].navigateURL,
                            title: res["data"].userModules[i].moduleName,
                            icon: res["data"].userModules[i].iconCSS,
                            type: "link",
                            code: res["data"].userModules[i].moduleCode,
                            active: false,
                            showTopAds: res["data"].userModules[i].showTopAds
                        });
                    }
                }
                for (var i = 0; i < res["data"].userSubMenus; i++) {
                    res["data"].userSubMenus[i].isActiveMenu = false;
                }
                this._commonService.userMenus = res["data"].userSubMenus;
                this._commonService.IWantToMenu = res["data"].userIWantToMenu;
            },
            (err: any) => { });
    }
    ngAfterViewInit() {

        

        setTimeout(() => {
            feather.replace();
        });
    }

    public getRouterOutletState(outlet) {
        return outlet.isActivated ? outlet.activatedRoute : '';
    }

    get layoutClass() {
        switch (this.layout.config.settings.layout) {
            case "Dubai":
                return "compact-wrapper"
            case "London":
                return "only-body"
            case "Seoul":
                return "compact-wrapper modern-type"
            case "LosAngeles":
                return this.navServices.horizontal ? "horizontal-wrapper material-type" : "compact-wrapper material-type"
            case "Paris":
                return "compact-wrapper dark-sidebar"
            case "Tokyo":
                return "compact-sidebar"
            case "Madrid":
                return "compact-wrapper color-sidebar"
            case "Moscow":
                return "compact-sidebar compact-small"
            case "NewYork":
                return "compact-wrapper box-layout"
            case "Singapore":
                return this.navServices.horizontal ? "horizontal-wrapper enterprice-type" : "compact-wrapper enterprice-type"
            case "Rome":
                return "compact-sidebar compact-small material-icon"
            case "Barcelona":
                return this.navServices.horizontal ? "horizontal-wrapper enterprice-type advance-layout" : "compact-wrapper enterprice-type advance-layout"
            case "horizontal-wrapper":
                return this.navServices.horizontal ? "horizontal-wrapper" : "compact-wrapper"
            default:
                return "compact-wrapper"
        }
    }

    ngOnInit() {
        this.authorizeUser();
    }
    authorizeUser() {
        debugger;
        if (this.authenticationService._authentication == null) {
            this._router.navigate(['/auth/login'], { queryParams: { returnUrl: this._router.routerState.snapshot.url } });
        }
        else if (this.authenticationService._authentication.isAuth) {
            this.getUserMenu(this.authenticationService._authentication.id, this.authenticationService._authentication.userName);

            var returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
            if (returnUrl != "/")
                this._router.navigate([returnUrl]);
        }
        else {
            this._commonService.ShowMessage('info', 'Please login with your username and password', '');
            this._router.navigate(['/auth/login'], { queryParams: { returnUrl: this._router.routerState.snapshot.url } });
        }
    }

}
